<div class="bg-white dark:bg-secondary-700">

  <!-- Filters -->

  <section aria-labelledby="filter-heading" class="grid items-center border-t border-gray-100 dark:border-[#3b4377]">
    <h2 id="filter-heading" class="sr-only">Filters</h2>
    <div class="relative col-start-1 row-start-1" [ngClass]="{'py-[0.68rem]': getActiveFilters().length > 0, 'py-4': getActiveFilters().length === 0}">
      <div class="mx-auto flex items-center px-4 text-sm sm:px-6 lg:px-6 justify-between">
        <div class="flex items-center space-x-6 divide-x divide-gray-200">
          <div>
            <button type="button" class="group flex items-center font-medium text-secondary/75 dark:text-white hover:opacity-90" aria-controls="disclosure-1" aria-expanded="false" (click)="toggleFilters()">
              <svg class="mr-2 h-5 w-5 flex-none text-secondary/75 group-hover:opacity-90" aria-hidden="true" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M2.628 1.601C5.028 1.206 7.49 1 10 1s4.973.206 7.372.601a.75.75 0 01.628.74v2.288a2.25 2.25 0 01-.659 1.59l-4.682 4.683a2.25 2.25 0 00-.659 1.59v3.037c0 .684-.31 1.33-.844 1.757l-1.937 1.55A.75.75 0 018 18.25v-5.757a2.25 2.25 0 00-.659-1.591L2.659 6.22A2.25 2.25 0 012 4.629V2.34a.75.75 0 01.628-.74z" clip-rule="evenodd" />
              </svg>

              <div class="flex items-center">
                {{ getActiveFilters().length > 0 ? getActiveFilters().length : '' }}
                {{ getActiveFilters().length === 1 ? 'Filter' : 'Filters' }}
              </div>

            </button>
          </div>
          <div class="pl-6">

            <div class="flex">

              <!-- Active Filters -->
              <div class="pr-2">
                <div class="-m-1 flex flex-wrap items-center">
                  <span *ngFor="let filter of getActiveFilters()" class="m-1 inline-flex items-center rounded-full border border-gray-200 bg-white py-1 pl-3 pr-2 text-sm font-medium text-gray-900">
                    <span>{{ filter.label }}</span>
                    <button type="button" class="ml-1 inline-flex h-4 w-4 flex-shrink-0 rounded-full p-1 text-gray-400 hover:bg-gray-200 hover:text-gray-500" (click)="removeFilter(filter.category, filter.value)">
                      <span class="sr-only">Remove filter for {{ filter.label }}</span>
                      <svg class="h-2 w-2" stroke="currentColor" fill="none" viewBox="0 0 8 8">
                        <path stroke-linecap="round" stroke-width="1.5" d="M1 1l6 6m0-6L1 7" />
                      </svg>
                    </button>
                  </span>
                </div>
              </div>

              <button *ngIf="getActiveFilters().length > 0" type="button" class="text-gray-500 flex items-center" (click)="clearAllFilters()">
                Clear all
              </button>

            </div>

          </div>
        </div>

        <div class="flex items-center gap-3">

          <!-- Date Range -->
          <app-reports-date-range [value]="dateRange" (dateRangeChanged)="onDateRangeChange($event)"></app-reports-date-range>

          <!-- Sort -->
          <app-reports-sort [value]="sort" (sortChanged)="onSortChange($event)"></app-reports-sort>

          <!-- Export Button -->
          <span [matTooltip]="disableExport ? 'Available soon' : ''"
                matTooltipPosition="above"
                matTooltipClass="custom-tooltip"
                class="inline-block">
            <button
              type="button"
              (click)="onExport()"
              [disabled]="exporting || disableExport"
              class="inline-flex items-center px-4 py-1.5 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors duration-150 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <svg *ngIf="exporting" class="animate-spin h-4 w-4 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              {{ exporting ? 'Exporting...' : (selectedCount > 0 ? 'Export Selected (' + selectedCount + ')' : 'Export All') }}
            </button>
          </span>

        </div>
      </div>
    </div>

    <div [ngClass]="{'hidden': !filtersOpen, 'block': filtersOpen, 'transition': true, 'duration-500': true}" class="border-t border-gray-200 py-10" id="disclosure-1">
      <div class="mx-auto px-4 text-sm sm:px-6 md:gap-x-6 lg:px-8">
        <div class="grid auto-rows-min grid-cols-1 gap-y-10 md:grid-cols-6 md:gap-x-6">
          <!-- Filters content here -->

          <!-- Role Filter -->
          <fieldset>
            <legend class="block font-medium dark:text-primary-200">Role</legend>
            <div class="space-y-6 pt-6 sm:space-y-4 sm:pt-4">
              <div *ngFor="let role of filterOptions.roles" class="flex items-center text-base sm:text-sm">
                <input [id]="'role-' + role.value" [name]="'roles[]'" [value]="role.value" type="checkbox" class="h-4 w-4 flex-shrink-0 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                       [checked]="isSelected('roles', role.value)"
                       (change)="onFilterChange('roles', role.value, $event)">
                <label [for]="'role-' + role.value" class="ml-3 min-w-0 flex-1 text-gray-600 dark:text-primary-200">{{ role.label }}</label>
              </div>
            </div>
          </fieldset>

          <!-- Deal Stage Filter -->
          <fieldset>
            <legend class="block font-medium dark:text-primary-200">Deal Stage</legend>
            <div class="space-y-6 pt-6 sm:space-y-4 sm:pt-4">
              <div *ngFor="let stage of filterOptions.dealStages" class="flex items-center text-base sm:text-sm">
                <input [id]="'deal-stage-' + stage.value" [name]="'dealStages[]'" [value]="stage.value" type="checkbox" class="h-4 w-4 flex-shrink-0 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                       [checked]="isSelected('dealStages', stage.value)"
                       (change)="onFilterChange('dealStages', stage.value, $event)">
                <label [for]="'deal-stage-' + stage.value" class="ml-3 min-w-0 flex-1 text-gray-600 dark:text-primary-200">{{ stage.label }}</label>
              </div>
            </div>
          </fieldset>

          <!-- Deal Value Filter -->
          <fieldset>
            <legend class="block font-medium dark:text-primary-200">Deal Value</legend>
            <div class="space-y-6 pt-6 sm:space-y-4 sm:pt-4">
              <div *ngFor="let value of filterOptions.dealValues" class="flex items-center text-base sm:text-sm">
                <input [id]="'deal-value-' + value.value" [name]="'dealValue[]'" [value]="value.value" type="checkbox" class="h-4 w-4 flex-shrink-0 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                       [checked]="isSelected('dealValues', value.value)"
                       (change)="onFilterChange('dealValues', value.value, $event)">
                <label [for]="'deal-value-' + value.value" class="ml-3 min-w-0 flex-1 text-gray-600 dark:text-primary-200">{{ value.label }}</label>
              </div>
            </div>
          </fieldset>

          <!-- Status Filter -->
          <fieldset>
            <legend class="block font-medium dark:text-primary-200">Status</legend>
            <div class="space-y-6 pt-6 sm:space-y-4 sm:pt-4">
              <div *ngFor="let value of filterOptions.statuses" class="flex items-center text-base sm:text-sm">
                <input [id]="'status-' + value.value" [name]="'statuses[]'" [value]="value.value" type="checkbox" class="h-4 w-4 flex-shrink-0 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                       [checked]="isSelected('statuses', value.value)"
                       (change)="onFilterChange('statuses', value.value, $event)">
                <label [for]="'status-' + value.value" class="ml-3 min-w-0 flex-1 text-gray-600 dark:text-primary-200">{{ value.label }}</label>
              </div>
            </div>
          </fieldset>

          <!-- Close Dates -->
          <fieldset>
            <legend class="block font-medium dark:text-primary-200">Close Dates</legend>
            <div class="space-y-6 pt-6 sm:space-y-4 sm:pt-4">
              <div *ngFor="let value of filterOptions.closeDates" class="flex items-center text-base sm:text-sm">
                <input [id]="'close-date-' + value.value" [name]="'closeDates[]'" [value]="value.value" type="checkbox" class="h-4 w-4 flex-shrink-0 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                       [checked]="isSelected('closeDates', value.value)"
                       (change)="onFilterChange('closeDates', value.value, $event)">
                <label [for]="'close-date-' + value.value" class="ml-3 min-w-0 flex-1 text-gray-600 dark:text-primary-200">{{ value.label }}</label>
              </div>
            </div>
          </fieldset>

          <div>

            <!-- Close Dates -->
            <fieldset class="mb-12">
              <legend class="block font-medium dark:text-primary-200">My Judgement</legend>
              <div class="space-y-6 pt-6 sm:space-y-4 sm:pt-4">
                <div *ngFor="let value of filterOptions.myJudgement" class="flex items-center text-base sm:text-sm">
                  <input [id]="'my-judgement-' + value.value" [name]="'myJudgement[]'" [value]="value.value" type="checkbox" class="h-4 w-4 flex-shrink-0 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                         [checked]="isSelected('myJudgement', value.value)"
                         (change)="onFilterChange('myJudgement', value.value, $event)">
                  <label [for]="'my-judgement-' + value.value" class="ml-3 min-w-0 flex-1 text-gray-600 dark:text-primary-200">{{ value.label }}</label>
                </div>
              </div>
            </fieldset>

            <!-- ICP Name -->
            <fieldset>
              <legend class="block font-medium dark:text-primary-200">ICP Name</legend>
              <div class="space-y-6 pt-6 sm:space-y-4 sm:pt-4">
                <div *ngFor="let value of filterOptions.icpName" class="flex items-center text-base sm:text-sm">
                  <input [id]="'icp-name-' + value.value" [name]="'icpName[]'" [value]="value.value" type="checkbox" class="h-4 w-4 flex-shrink-0 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                         [checked]="isSelected('icpName', value.value)"
                         (change)="onFilterChange('icpName', value.value, $event)">
                  <label [for]="'icp-name-' + value.value" class="ml-3 min-w-0 flex-1 text-gray-600 dark:text-primary-200">{{ value.label }}</label>
                </div>
              </div>
            </fieldset>

          </div>

        </div>

      </div>
    </div>

    <!--
    <div class="col-start-1 row-start-1 py-4">
      <div class="mx-auto flex justify-end px-4 sm:px-6 lg:px-6">
        <div class="relative inline-block">
          <div class="flex">
            <button type="button" class="group inline-flex justify-center text-sm font-medium text-gray-700 hover:text-gray-900" id="menu-button" aria-expanded="false" aria-haspopup="true" (click)="toggleSort()">
              Sort
              <svg class="-mr-1 ml-1 h-5 w-5 flex-shrink-0 text-gray-400 group-hover:text-gray-500" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path fill-rule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clip-rule="evenodd" />
              </svg>
            </button>
          </div>
          <div [ngClass]="{'hidden': !sortOpen, 'block': sortOpen, 'transition': true, 'duration-500': true}" class="absolute right-0 z-10 mt-2 w-40 origin-top-right rounded-md bg-white shadow-2xl ring-1 ring-black ring-opacity-5 focus:outline-none" role="menu" aria-orientation="vertical" aria-labelledby="menu-button" tabindex="-1">
            <div class="py-1" role="none">
              <a href="#" class="block px-4 py-2 text-sm font-medium text-gray-900" role="menuitem" tabindex="-1" id="menu-item-0">Most Popular</a>
              <a href="#" class="block px-4 py-2 text-sm text-gray-500" role="menuitem" tabindex="-1" id="menu-item-1">Best Rating</a>
              <a href="#" class="block px-4 py-2 text-sm text-gray-500" role="menuitem" tabindex="-1" id="menu-item-2">Newest</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    -->

  </section>

</div>
